import Admin from "../layouts/Admin/Admin";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Dashboard from "../views/Admin/Dashboard";
import Persons from "../views/Admin/Persons";
import Person from "../views/Admin/Person";

import Organizations from "../views/Admin/Organizations";
import Organization from "../views/Admin/Organization";

import Users from "../views/Admin/Users";
import Csat from "../views/Admin/Csat";
import Nps from "../views/Admin/NpsList";
import NpsScore from "../views/Admin/NpsScore";
import NpsEdit from "../views/Admin/NpsEdit";
import CesProducts from "../views/Admin/CesProducts";
import Messaging from "../views/Admin/Messaging";
import Message from "../views/Admin/Message";
import Segments from "../views/Admin/Segments";
import Fopag from "../views/Admin/Fopag";
import CloudListFolder from "../views/Admin/Cloud";
import TaskTypes from "../views/Admin/TaskTypes";
import Rooms from "../views/Admin/Rooms";

export const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Admin />}>
          <Route index element={<Dashboard />} />
          <Route path="persons">
            <Route index element={<Persons />} />
            <Route
              path=":personID"
              element={<Person />}
              key={Math.random() * 1000}
            />
          </Route>
          <Route path="organizations">
            <Route index element={<Organizations />} />
            <Route path=":organizationID" element={<Organization />} />
          </Route>
          <Route path="users">
            <Route index element={<Users />} />
          </Route>
          <Route path="cloud">
            <Route index element={<CloudListFolder />} />
          </Route>
          <Route path="surveys">
            <Route path="csat">
              <Route index element={<Csat />} />
            </Route>
            <Route path="nps">
              <Route index element={<Nps />} />
              <Route path=":npsID" element={<NpsScore />} />
              <Route path="edit/:npsID" element={<NpsEdit />} />
            </Route>
            <Route path="ces-products">
              <Route index element={<CesProducts />} />
            </Route>
          </Route>
          <Route path="messaging">
            <Route index element={<Messaging />} />
            <Route path=":messageID" element={<Message />} />
            <Route path="edit/:messageID" element={<Message />} />
          </Route>
          <Route path="fopag">
            <Route index element={<Fopag />} />
          </Route>
          <Route path="task-types">
            <Route index element={<TaskTypes />} />
          </Route>
          <Route path="rooms">
            <Route index element={<Rooms />} />
          </Route>
          <Route path="segments">
            <Route index element={<Segments />} />
          </Route>
          <Route path="*" element={<Dashboard />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
